// Catálogo comercial revisado em 08/10/2026. Rotinas da base não são itens de cobrança.
// Chaves frontend: o mapeamento real de permissões continua dependente do backend.
export const catalogRevision = 2
export const catalog = [
  {
    "id": "group:0",
    "label": "Geral",
    "children": [
      {
        "id": "section:pagina-inicial",
        "label": "Página Inicial",
        "children": [
          {
            "id": "erp:/paginaInicial",
            "label": "Página Inicial",
            "path": "/paginaInicial"
          }
        ]
      },
      {
        "id": "section:conversas",
        "label": "Conversas",
        "children": [
          {
            "id": "erp:/conversas",
            "label": "Conversas",
            "path": "/conversas"
          }
        ]
      }
    ]
  },
  {
    "id": "group:1",
    "label": "Cadastros",
    "children": [
      {
        "id": "section:pessoas",
        "label": "Pessoas",
        "children": [
          {
            "id": "erp:/Clientes",
            "label": "Clientes",
            "path": "/Clientes"
          },
          {
            "id": "erp:/Fornecedores",
            "label": "Fornecedores",
            "path": "/Fornecedores"
          },
          {
            "id": "erp:/Vendedores",
            "label": "Vendedores",
            "path": "/Vendedores"
          },
          {
            "id": "erp:/Tecnicos",
            "label": "Técnicos",
            "path": "/Tecnicos"
          },
          {
            "id": "erp:/Colaboradores",
            "label": "Colaboradores",
            "path": "/Colaboradores"
          },
          {
            "id": "erp:/Transportadores",
            "label": "Transportadores",
            "path": "/Transportadores"
          },
          {
            "id": "erp:/pessoas/ramos-atividade",
            "label": "Ramos de atividade",
            "path": "/pessoas/ramos-atividade"
          }
        ]
      },
      {
        "id": "section:produtos",
        "label": "Produtos",
        "children": [
          {
            "id": "product-maintenance",
            "label": "Produtos",
            "children": [
              {
                "id": "erp:/produtos",
                "label": "Produtos",
                "path": "/produtos"
              },
              {
                "id": "erp:/produtos/cargas-balanca",
                "label": "Cargas balança",
                "path": "/produtos/cargas-balanca"
              },
              {
                "id": "erp:/grupos",
                "label": "Grupos",
                "path": "/grupos"
              },
              {
                "id": "erp:/marcas",
                "label": "Marcas",
                "path": "/marcas"
              },
              {
                "id": "erp:/unidadesMedida",
                "label": "Unidades de medida",
                "path": "/unidadesMedida"
              },
              {
                "id": "erp:/setores",
                "label": "Setores",
                "path": "/setores"
              },
              {
                "id": "erp:/produtos/locais-estoque",
                "label": "Locais de estoque",
                "path": "/produtos/locais-estoque"
              }
            ]
          },
          {
            "id": "erp:/produtos/tabelas-preco",
            "label": "Tabelas de preço",
            "path": "/produtos/tabelas-preco"
          },
          {
            "id": "erp:/produtos/tributacao",
            "label": "Tributação",
            "path": "/produtos/tributacao"
          }
        ]
      },
      {
        "id": "section:servicos",
        "label": "Serviços",
        "children": [
          {
            "id": "erp:/servicos",
            "label": "Serviços",
            "path": "/servicos"
          },
          {
            "id": "erp:/servicos/tipos-os",
            "label": "Tipos OS",
            "path": "/servicos/tipos-os"
          },
          {
            "id": "erp:/servicos/equipamentos",
            "label": "Equipamentos",
            "path": "/servicos/equipamentos"
          },
          {
            "id": "erp:/operacional/checklist-modelos",
            "label": "Modelos de Checklist",
            "path": "/operacional/checklist-modelos"
          }
        ]
      },
      {
        "id": "section:pdv-cadastros",
        "label": "Comercial",
        "children": [
          {
            "id": "erp:/cadastros/comercial/pontos-venda",
            "label": "Pontos de Venda",
            "path": "/cadastros/comercial/pontos-venda"
          },
          {
            "id": "erp:/cadastros/comercial/turnos",
            "label": "Turnos",
            "path": "/cadastros/comercial/turnos"
          },
          {
            "id": "erp:/cadastros/comercial/feriados",
            "label": "Feriados",
            "path": "/cadastros/comercial/feriados"
          },
          {
            "id": "erp:/cadastros/comercial/promocoes",
            "label": "Promoções",
            "path": "/cadastros/comercial/promocoes"
          }
        ]
      },
      {
        "id": "section:financeiro-cadastros",
        "label": "Financeiro · Cadastros",
        "children": [
          {
            "id": "erp:/planoContas",
            "label": "Plano de Contas",
            "path": "/planoContas"
          },
          {
            "id": "erp:/centroCustos",
            "label": "Centro de Custos",
            "path": "/centroCustos"
          },
          {
            "id": "erp:/contasOperacionais",
            "label": "Contas Operacionais",
            "path": "/contasOperacionais"
          },
          {
            "id": "erp:/administradorasCartao",
            "label": "Administradoras de Cartão",
            "path": "/administradorasCartao"
          },
          {
            "id": "erp:/formasPagamento",
            "label": "Formas de Pagamento",
            "path": "/formasPagamento"
          },
          {
            "id": "erp:/condicoesPagamento",
            "label": "Condições de Pagamento",
            "path": "/condicoesPagamento"
          }
        ]
      },
      {
        "id": "section:usuarios",
        "label": "Usuarios",
        "children": [
          {
            "id": "erp:/usuarios",
            "label": "Usuarios",
            "path": "/usuarios"
          }
        ]
      },
      {
        "id": "section:empresas",
        "label": "Empresas",
        "children": [
          {
            "id": "erp:/empresas",
            "label": "Empresas",
            "path": "/empresas"
          }
        ]
      }
    ]
  },
  {
    "id": "group:2",
    "label": "Operações",
    "children": [
      {
        "id": "section:comercial",
        "label": "Comercial",
        "children": [
          {
            "id": "erp:/comercial/orcamento",
            "label": "Orçamento",
            "path": "/comercial/orcamento"
          },
          {
            "id": "erp:/comercial/pedido",
            "label": "Pedido",
            "path": "/comercial/pedido"
          },
          {
            "id": "erp:/comercial/devolucoes",
            "label": "Devolução de vendas",
            "path": "/comercial/devolucoes"
          },
          {
            "id": "erp:/comercial/condicional",
            "label": "Condicional",
            "path": "/comercial/condicional"
          },
          {
            "id": "erp:/comercial/ordem-servico",
            "label": "Ordem de serviço",
            "path": "/comercial/ordem-servico"
          }
        ]
      },
      {
        "id": "section:estoque",
        "label": "Estoque",
        "children": [
          {
            "id": "erp:/estoque/ajuste",
            "label": "Ajuste de estoque",
            "path": "/estoque/ajuste"
          },
          {
            "id": "erp:/estoque/pedidos-compra",
            "label": "Pedido de compra",
            "path": "/estoque/pedidos-compra"
          },
          {
            "id": "erp:/estoque/transferencias",
            "label": "Transferência de estoque",
            "path": "/estoque/transferencias"
          },
          {
            "id": "erp:/estoque/gondola",
            "label": "Controle de gôndola",
            "path": "/estoque/gondola"
          },
          {
            "id": "erp:/estoque/entradas-mercadoria",
            "label": "Entrada de mercadoria",
            "path": "/estoque/entradas-mercadoria"
          },
          {
            "id": "erp:/estoque/devolucoes-compra",
            "label": "Devolução de compra",
            "path": "/estoque/devolucoes-compra"
          }
        ]
      },
      {
        "id": "erp:/pdv/caixa",
        "label": "PDV",
        "path": "/pdv/caixa",
        "billable": true,
        "description": "Sessão de caixa incluída. Supervisor é opcional.",
        "children": [
          {
            "id": "erp:/pdv/supervisor",
            "label": "Supervisor",
            "path": "/pdv/supervisor"
          }
        ]
      },
      {
        "id": "module:pdv-offline",
        "label": "PDV Offline",
        "description": "Inclui Gerenciamento, Monitoramento, Cargas, Atualizações, Personalização."
      },
      {
        "id": "section:financeiro-operacional",
        "label": "Financeiro · Operacional",
        "children": [
          {
            "id": "erp:/contasAPagar",
            "label": "Contas a Pagar",
            "path": "/contasAPagar"
          },
          {
            "id": "erp:/contasAReceber",
            "label": "Contas a Receber",
            "path": "/contasAReceber"
          },
          {
            "id": "erp:/financeiro/borderos-cartao",
            "label": "Borderô de Cartões",
            "path": "/financeiro/borderos-cartao"
          },
          {
            "id": "erp:/financeiro/saldo-contas",
            "label": "Saldo de contas",
            "path": "/financeiro/saldo-contas"
          },
          {
            "id": "erp:/financeiro/fechamentos-caixa",
            "label": "Fechamentos de Caixa",
            "path": "/financeiro/fechamentos-caixa"
          }
        ]
      },
      {
        "id": "module:convenios",
        "label": "Convênios",
        "description": "Inclui Afiliados, Relatórios."
      }
    ]
  },
  {
    "id": "group:3",
    "label": "Mov. Fiscais",
    "children": [
      {
        "id": "section:fiscal",
        "label": "Mov. Fiscais",
        "children": [
          {
            "id": "erp:/fiscal/venda",
            "label": "Notas Fiscais",
            "path": "/fiscal/venda"
          },
          {
            "id": "erp:/fiscal/servico",
            "label": "Notas de Serviço",
            "path": "/fiscal/servico"
          },
          {
            "id": "erp:/fiscal/manifestacao-destinatario",
            "label": "Manifestação destinatário",
            "path": "/fiscal/manifestacao-destinatario"
          },
          {
            "id": "erp:/fiscal/cte",
            "label": "Conhecimento Transporte",
            "path": "/fiscal/cte"
          },
          {
            "id": "erp:/fiscal/mdfe",
            "label": "Manifesto Documentos",
            "path": "/fiscal/mdfe"
          },
          {
            "id": "erp:/fiscal/ciot",
            "label": "CIOT",
            "path": "/fiscal/ciot"
          }
        ]
      },
      {
        "id": "section:arquivos-contabeis",
        "label": "Arquivos Contábeis",
        "children": [
          {
            "id": "erp:/fiscal/arquivos/xml",
            "label": "Exportação XML",
            "path": "/fiscal/arquivos/xml"
          },
          {
            "id": "erp:/fiscal/arquivos/sped",
            "label": "SPED Fiscal",
            "path": "/fiscal/arquivos/sped"
          },
          {
            "id": "erp:/fiscal/arquivos/faturamento",
            "label": "Faturamento",
            "path": "/fiscal/arquivos/faturamento"
          }
        ]
      }
    ]
  },
  {
    "id": "group:4",
    "label": "Análises",
    "children": [
      {
        "id": "module:relatorios",
        "label": "Relatórios",
        "description": "Inclui Comissões, Fluxo de Caixa, Posição de estoque, Fechamentos PDV, Vendas PDV, Ticket Médio, Relatórios Dinâmicos."
      }
    ]
  }
]

export const resources = [
 { id: "users", label: "Usuários", unit: "usuário", minimum: 1 },
 { id: "pdvTerminals", label: "Terminais PDV", unit: "terminal", minimum: 0 }
]

export function nodes(tree = catalog) { return tree.flatMap(node => [node, ...(node.children ? nodes(node.children) : [])]) }
export function leaves(tree = catalog) { return tree.flatMap(node => node.children ? [...(node.billable ? [node] : []), ...leaves(node.children)] : [node]) }
export const legacyOptionAliases = {
  "erp:/pdvs-offline/gerenciamento": "module:pdv-offline",
  "erp:/pdvs-offline/monitoramento": "module:pdv-offline",
  "erp:/pdvs-offline/cargas": "module:pdv-offline",
  "erp:/pdvs-offline/atualizacoes": "module:pdv-offline",
  "erp:/pdvs-offline/personalizacao": "module:pdv-offline",
  "erp:/convenios/afiliados": "module:convenios",
  "erp:/convenios/relatorios": "module:convenios",
  "erp:/relatorios/comissoes": "module:relatorios",
  "erp:/relatorios/fluxo-caixa": "module:relatorios",
  "erp:/relatorios/estoque-posicao": "module:relatorios",
  "erp:/relatorios/pdv/fechamentos": "module:relatorios",
  "erp:/relatorios/pdv/vendas": "module:relatorios",
  "erp:/relatorios/pdv/ticket-medio": "module:relatorios",
  "erp:/relatorios/dinamico": "module:relatorios",
  "erp:/configuracoes/fiscal": null,
  "erp:/configuracoes/operacoes": null,
  "erp:/configuracoes/pdv": null,
  "erp:/configuracoes/comercial": null,
  "erp:/configuracoes/produtos-servicos": null,
  "erp:/configuracoes/pessoas": null,
  "erp:/configuracoes/financeiro": null,
  "erp:/configuracoes/estoque": null,
  "erp:/changelog": null,
  "erp:/assinatura": null,
  "erp:/sistema/suporte/tickets": null,
  "erp:/sistema/reportar-suporte": null
}
export function normalizeOptions(ids = []) {
  const mapped = ids.map(id => Object.prototype.hasOwnProperty.call(legacyOptionAliases, id) ? legacyOptionAliases[id] : id).filter(Boolean)
  if (mapped.includes('erp:/pdv/supervisor')) mapped.push('erp:/pdv/caixa')
  return [...new Set(mapped)]
}
